import React, { Component } from 'react'
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBContainer, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, } from 'mdbreact'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faExternalLink } from '@fortawesome/pro-duotone-svg-icons'
import { Link } from 'gatsby'

class NavBar extends Component {
  state = {
    collapsed: false,
  }

handleTogglerClick = () => {
  this.setState({
    collapsed: !this.state.collapsed,
  })
}

componentDidMount() {  
  const str = window.location.pathname.substr(1,window.location.pathname.length-1)
  const len = str.indexOf("/")
  this.setState({ 
    parentNav: len < 0 ? str : str.substr(0, len) 
  })
}

render() {
  const overlay = (
    <div
      id="sidenav-overlay"
      style={{ backgroundColor: 'transparent' }}
      onClick={this.handleTogglerClick}
    />
  )

  const isActive = ({ isCurrent }) => {
    return isCurrent ? { className: "nav-link active" } : {}
  }

  const isPartiallyActive = ({
    isPartiallyCurrent
  }) => {
    return isPartiallyCurrent
      ? { className: "nav-link active" }
      : {}
  }

    return (
      <div>
        <MDBNavbar
          color="top-nav-collapse"
          dark
          expand="lg"
          fixed="top"
          scrolling
          transparent
        >
          <MDBContainer>
            <MDBNavbarBrand>
              <Link to="/">
                <img
                  src="/softlanding-logo-we.svg"
                  alt="SoftLanding logo"
                  title="SoftLanding Systems, Inc."
                  height="52"
                />
              </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler
              aria-label="Mobile Navigation Button"
              onClick={this.handleTogglerClick}
            />
            <MDBCollapse isOpen={this.state.collapsed} navbar>
              <MDBNavbarNav right>
                <MDBNavItem>
                  <MDBDropdown>
                  <MDBDropdownToggle nav caret className={ this.state.parentNav === 'solutions' ? 'active' : '' }>
                      <span className="mr-1">Solutions</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-usi">
                     <MDBDropdownItem href="/solutions/">
                        Solutions
                      </MDBDropdownItem>
                     <MDBDropdownItem href="/solutions/application-lifecycle-management/">
                       - Application lifecycle management
                     </MDBDropdownItem>
                     <MDBDropdownItem href="/solutions/automated-operations/">
                       - Automated operations
                     </MDBDropdownItem>
                     <MDBDropdownItem href="/solutions/enterprise-content-management/">
                       - Enterprise content management
                     </MDBDropdownItem>
                     <MDBDropdownItem href="/solutions/legacy-application-decommissioning/">
                       - Legacy application decommissioning
                     </MDBDropdownItem>
                     <MDBDropdownItem href="/solutions/menu-management/">
                       - Menu management
                     </MDBDropdownItem>
                     <MDBDropdownItem href="/solutions/performance-management/">
                       - Performance management
                     </MDBDropdownItem>
                     <MDBDropdownItem href="/solutions/problem-and-incident-management/">
                       - Problem and incident management
                     </MDBDropdownItem>                      
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem> 

                <MDBNavItem>
                  <Link to="/products/" getProps={isPartiallyActive} className="nav-link">
                    Products
                  </Link>
                </MDBNavItem>
                
                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret className={ this.state.parentNav === 'services' ? 'active' : '' }>
                      <span className="mr-1">Services</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-usi">
                      <MDBDropdownItem href="/services/">
                        Services
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/product-levels/">
                        - Product levels
                      </MDBDropdownItem>                      
                      <MDBDropdownItem href="/services/support/">
                        - Support
                      </MDBDropdownItem>
                      <MDBDropdownItem href="https://support.softlanding.com/" target="_blank">
                        - Customer portal
                        <FontAwesomeIcon icon={faExternalLink} className="ml-2" />
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>                             
                <MDBNavItem>
                  <MDBDropdown>
                  <MDBDropdownToggle nav caret className={ (this.state.parentNav === 'about' || this.state.parentNav === 'contact' || this.state.parentNav === 'news' || this.state.parentNav === 'partners' || this.state.parentNav === 'resources') ? 'active' : '' }>
                      <span className="mr-1">Company</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-usi">
                    <MDBDropdownItem href="/contact/">
                        Contact us
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/news/">
                        Newsroom
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/partners/">
                        Partners
                      </MDBDropdownItem>                      
                      <MDBDropdownItem href="/resources/">
                        Resources
                      </MDBDropdownItem>                   
                      <hr className="nav" />
                      <MDBDropdownItem href="/about/">
                        About Us
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                <Link to="/search/" className="nav-link d-none d-lg-block" aria-label="Search">
                    <FontAwesomeIcon icon={faSearch} />
                  </Link>
                  <Link to="/search/" className="nav-link d-lg-none d-sm-block" aria-label="Search">
                    Search
                  </Link>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
        {this.state.collapsed && overlay}
      </div>
    )
  }
}

export default NavBar